import { Component } from '@angular/core';
import { FilterChangedEvent, GridOptions, IFloatingFilter, IFloatingFilterParams } from 'ag-grid-community';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettingsService, IStatus, Settings } from 'src/app/settings/app-settings.service';

@Component({
  selector: 'app-schedule-status-floating-filter',
  templateUrl: './schedule-status-floating-filter.component.html',
  styleUrls: ['./schedule-status-floating-filter.component.scss']
})
export class ScheduleStatusFloatingFilterComponent implements IFloatingFilter {

  params: IFloatingFilterParams | undefined;
  gridOptions: GridOptions = {};
  options: Observable<IStatus[]> | undefined;
  selectedStatus = "All";

  constructor(private settingsService: AppSettingsService) {
    this.options = this.settingsService.settings.pipe(map(items => items.find(x => x.Key === Settings.ScheduleStatus)?.Data))
  }

  onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
    if (!parentModel) {
      this.selectedStatus = "All";
    }
    else {
      this.selectedStatus = parentModel;
    }
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  valueChanged() {
    this.params?.parentFilterInstance((instance) => {
      instance.setModel(this.selectedStatus);
    });
  }
}
